import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  min-height: ${props => props.minHeight || '300px'};
  text-align: center;
`;

const Icon = styled.div`
  font-size: 3rem;
  color: #cccccc;
  margin-bottom: 1rem;
`;

const Title = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #454545;
  margin-bottom: 0.5rem;
`;

const Description = styled.p`
  font-size: 0.875rem;
  color: #666666;
  max-width: 400px;
`;

const EmptyState = ({ title, description, icon, minHeight }) => {
  return (
    <Container minHeight={minHeight}>
      {icon && <Icon>{icon}</Icon>}
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Container>
  );
};

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  icon: PropTypes.string,
  minHeight: PropTypes.string
};

EmptyState.defaultProps = {
  description: 'Try adjusting your filters to see results.',
  icon: '📊',
  minHeight: '300px'
};

export default EmptyState;
